module.exports = __webpack_public_path__ + "media/send.71527001.wav";